import { Avatar, Col, Row } from "antd";
import { UserOutlined, UploadOutlined, CheckCircleOutlined } from "@ant-design/icons";
import ProcedureImage from "../../assets/procedures.jpg";
import RecruitorImage from "../../assets/Recruitor.jpg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1440 },
    items: 1,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 1440, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
    slidesToSlide: 1,
  },
  smallTablet: {
    breakpoint: { max: 768, min: 576 },
    items: 1,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 576, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const Procedures = () => {
  return (
    <div className="max-w-6xl mx-auto py-12 mb-12 px-4 md:px-0 my-16">
      <h3 className="text-xl uppercase tracking-[0.2em] text-gray-400 font-medium mb-3">
        How it Works
      </h3>
      <h1 className="text-4xl md:text-5xl font-bold leading-tight tracking-[-0.02em] mb-8">
        Follow{" "}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-accepted">
          3 Simple Steps
        </span>{" "}
        to Launch Your Career
      </h1>

      <Carousel  responsive={responsive} swipeable={true} showDots={true} arrows={true} className="max-h-full">
        {/* Slide 1: Enumerator */}
        <div>
          <Row gutter={[24, 24]} className="flex flex-col md:flex-row">
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="flex justify-center items-center">
              <img
                alt="#"
                src={ProcedureImage}
                className="w-full h-[90%] object-contain"
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="py-0 md:py-0 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl uppercase tracking-[0.04em] text-green-500 font-bold mb-2">
                Enumerator
              </h3>
              <h1 className="text-xl md:text-3xl tracking-[0.01em] font-semibold leading-tight mb-8">
                Your Journey in{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-600 to-gray-500 font-semibold">
                  3 Easy Steps
                </span>
              </h1>

              <div className="mt-10 flex flex-col gap-y-10">
                {[
                  {
                    icon: <UserOutlined className="text-green-500" />,
                    title: "Build Your Profile",
                    description:
                      "Create a standout profile that highlights your skills, experience, and certifications. Upload your resume and supporting documents so recruiters can quickly see your expertise.",
                  },
                  {
                    icon: <UploadOutlined className="text-green-500" />,
                    title: "Explore Tailored Opportunities",
                    description:
                      "Browse through job listings curated just for you. Use intuitive filters like industry, location, and compensation to find the perfect opportunity that matches your career goals.",
                  },
                  {
                    icon: <CheckCircleOutlined className="text-green-500" />,
                    title: "Connect & Grow",
                    description:
                      "Apply seamlessly through our platform and stay updated on your application status. Engage with recruiters and join a community of professionals dedicated to advancing your career.",
                  },
                ].map((step, index) => (
                  <Row gutter={32} key={index}>
                    <Col span={2}>
                      <Avatar
                        size={35}
                        icon={step.icon}
                        className="bg-green-100 border-none"
                      />
                    </Col>
                    <Col span={22}>
                      <h2 className="text-xl md:text-2xl font-semibold leading-8 mb-2">
                        {step.title}
                      </h2>
                      <p className="font-normal text-base text-border">
                        {step.description}
                      </p>
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
          </Row>
        </div>

        {/* Slide 2: Recruiter */}
        <div>
          <Row gutter={[24, 24]} className="flex flex-col md:flex-row">
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="flex justify-center items-center">
              <img
                alt="#"
                src={RecruitorImage}
                className="w-full h-[90%] object-contain"
              />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="py-0 md:py-0 flex flex-col justify-center">
              <h3 className="text-3xl md:text-4xl uppercase tracking-[0.04em] text-green-500 font-bold mb-2">
                Recruiter
              </h3>
              <h1 className="text-xl md:text-3xl tracking-[0.01em] font-semibold leading-tight mb-8">
                Hire Top Enumerators in{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-600 to-gray-500">
                  3 Simple Steps
                </span>
              </h1>

              <div className="mt-10 flex flex-col gap-y-10">
                {[
                  {
                    icon: <UserOutlined className="text-green-500" />,
                    title: "Register & Verify",
                    description:
                      "Sign up with your recruiter account and complete your profile. Verify your organization’s credentials to build trust with top talent.",
                  },
                  {
                    icon: <UploadOutlined className="text-green-500" />,
                    title: "Post Your Job Listing",
                    description:
                      "Create detailed job posts that clearly outline the skills and experience you need. Our platform helps you reach a wide pool of qualified enumerators through smart matching and precise filters.",
                  },
                  {
                    icon: <CheckCircleOutlined className="text-green-500" />,
                    title: "Review & Hire",
                    description:
                      "Easily navigate through profiles, track applications, and communicate directly with candidates. Leverage our intuitive tools to select the right enumerators and bring your project to life.",
                  },
                ].map((step, index) => (
                  <Row gutter={32} key={index}>
                    <Col span={2}>
                      <Avatar
                        size={35}
                        icon={step.icon}
                        className="bg-green-100 border-none"
                      />
                    </Col>
                    <Col span={22}>
                      <h2 className="text-xl md:text-2xl font-semibold leading-8 mb-2">
                        {step.title}
                      </h2>
                      <p className="font-normal text-base text-border">
                        {step.description}
                      </p>
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </Carousel>
    </div>
  );
};

export default Procedures;